module.exports = __webpack_public_path__ + "static/media/swarm.f0b4053f.svg";